import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments'

export const GET_USER_BY_FIREBASE_ID = gql`
  query GetUserByFirebaseId($firebaseId: String!) {
    userByFirebaseId(firebaseId: $firebaseId) {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
